import type { SalesTimingReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const salesTimingKeys = {
  report: (filters: Pick<ReportFilters, 'branchId' | 'from' | 'to' | 'docType'>) =>
    ['reports', 'sales-timing', filters.branchId, filters.from, filters.to, filters.docType] as const,
};

export function fetchSalesTiming(
  filters: Pick<ReportFilters, 'branchId' | 'from' | 'to' | 'docType'>,
  signal?: AbortSignal,
): Promise<SalesTimingReport> {
  const query = queryString({
    branchId: filters.branchId,
    from: filters.from,
    to: filters.to,
    docType: filters.docType,
  });
  return portalApi.get<SalesTimingReport>(`/portal/reports/sales/timing${query}`, { signal });
}
